import React, { useState, useEffect } from 'react';
import './css/DesignCard.css';

const DesignCard = ({ design, onClick, loading }) => {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setRotation(prev => (prev + 1) % 360);
    }, 50);
    return () => clearInterval(interval);
  }, []);

  const renderPreview = () => {
    switch (design.id) {
      case 'Design1':
        return (
          <div className="preview-spinning-disk">
            <div 
              className="disk-circle" 
              style={{ transform: `rotate(${rotation}deg)` }}
            >
              <div className="disk-center"></div>
              <div className="disk-groove"></div>
              <div className="disk-groove-2"></div>
            </div>
          </div>
        );
      case 'Design2':
        return (
          <div className="preview-waveform">
            {[...Array(12)].map((_, i) => (
              <div 
                key={i} 
                className="wave-bar"
                style={{ 
                  height: `${30 + Math.sin((rotation / 20) + i) * 20}%`,
                  animationDelay: `${i * 0.1}s`
                }}
              />
            ))}
          </div>
        );
      case 'Design3':
        return (
          <div className="preview-album-grid">
            {[...Array(4)].map((_, i) => (
              <div 
                key={i} 
                className="grid-item"
                style={{ 
                  transform: `scale(${0.95 + Math.sin((rotation / 30) + i) * 0.05})` 
                }}
              />
            ))}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div 
      className={`design-card ${loading ? 'loading' : ''} ${design.isPremium ? 'premium' : ''}`}
      onClick={() => !loading && !design.isPremium && onClick(design.id)}
    >
      <div className="design-card-preview">
        {renderPreview()}
        {design.isPremium && (
          <div className="premium-overlay">
            <div className="premium-lock">🔒</div>
            <span className="premium-text">Premium</span>
          </div>
        )}
      </div>
      <div className="design-card-content">
        <h3 className="design-card-title">{design.name}</h3>
        <p className="design-card-description">{design.description}</p>
        <div className={`design-card-badge ${design.isPremium ? 'premium-badge' : ''}`}>
          {design.badge}
        </div>
      </div>
      {loading && (
        <div className="design-card-loading">
          <div className="spinner"></div>
        </div>
      )}
    </div>
  );
};

export default DesignCard;
